import {rupiahWithNegativeWithoutBracket} from 'utils/formatter'
class DefaultPaymentTable extends React.Component {
  render () {
    let {paymentMethods} = this.props
    let {cash_or_card, invoice, other} = paymentMethods.reports

    return (paymentMethods &&
      <table className='table mk-table-summary mk-table-fixed-hf report-table payment-table'>
        <thead>
          <tr>
            <th className='header-payment-method'>Payment Method</th>
            <th className='header-number-of-transactions'>Number of Transactions</th>
            <th className='header-total-collected'>Total Collected</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='body-payment-method parent'>Cash</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {cash_or_card[0].collected < 0 ? rupiahWithNegativeWithoutBracket(cash_or_card[0].collected) : 'Rp. 0'}
            </td>
          </tr>
          <tr>
            <td className='body-payment-method parent'>Debit / Credit</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {cash_or_card[1].collected < 0 ? rupiahWithNegativeWithoutBracket(cash_or_card[1].collected) : 'Rp. 0'}
            </td>
          </tr>
          <tr>
            <td className='body-payment-method parent'>Invoice</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {invoice[0].collected < 0 ? rupiahWithNegativeWithoutBracket(invoice[0].collected) : 'Rp. 0'}
            </td>
          </tr>
          <tr>
            <td className='body-payment-method parent'>Other</td>
            <td className='body-number-of-transactions' />
            <td className='body-total-collected' />
          </tr>
          <tr>
            <td className='body-payment-method child'>EDC</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {other[0].collected < 0 ? rupiahWithNegativeWithoutBracket(other[0].collected) : 'Rp. 0'}
            </td>
          </tr>
          <tr>
            <td className='body-payment-method child'>Gift Card</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {other[1].collected < 0 ? rupiahWithNegativeWithoutBracket(other[1].collected) : 'Rp. 0'}
            </td>
          </tr>
          <tr>
            <td className='body-payment-method child'>Other</td>
            <td className='body-number-of-transactions'>0</td>
            <td className='body-total-collected'>
              {other[2].collected < 0 ? rupiahWithNegativeWithoutBracket(other[2].collected) : 'Rp. 0'}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr className='divider text-total'>
            <td className='foot-payment-method'><b>Total</b></td>
            <td className='foot-number-of-transactions'><b>0</b></td>
            <td className='foot-total-collected'><b>
              {paymentMethods.total_collected < 0 ? rupiahWithNegativeWithoutBracket(paymentMethods.total_collected) : 'Rp. 0'}
            </b></td>
          </tr>
        </tfoot>
      </table>
    )
  }
}

DefaultPaymentTable.propTypes = {
  paymentMethods: React.PropTypes.object
}

export default DefaultPaymentTable



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/PaymentMethods/DefaultPaymentTable.js